/**
 * Every disposition the service can offer, in the words its button shows.
 *
 * **A copy of the service's `DISPOSITION_LABELS` (`app/periods.py`), held
 * EQUAL to it** by `tests/seam-vocabularies.test.ts` through
 * `vocabularies.json` — not merely covering the same keys. The service names
 * these buttons in its own sentences ("Choose: Move to its month, …"), so a
 * label changed here alone would leave the sentence naming a button that no
 * longer exists: C7, which ended every held sentence with slugs, from the other
 * side.
 *
 * It covered five of seven once, so a `direction_conflict` hold rendered two
 * buttons labelled `confirm_purchase` and `confirm_sales`, raw slugs.
 * Moved out of `Intake.tsx` (2026-09-28) so a test can import it.
 */
export const DISPOSITION_LABELS: Record<string, string> = {
  move: 'Move to its month',
  include_with_reason: 'Include with reason…',
  accept_with_reason: 'Accept with reason…',
  reparse: 'Let it through',
  confirm_purchase: 'It is a purchase',
  confirm_sales: 'It is a sale',
  reject: 'Reject',
}
